import { SelectedCustomer } from '@zet/utils/interface'
import { create } from 'zustand'

type customerStore = {
  selectedCustomer: SelectedCustomer | null
  setSelectedCustomer: (customer: SelectedCustomer | null) => void
  missingDetails: boolean
  setMissingDetails: (payload: boolean) => void
}

const useCustomerStore = create<customerStore>((set) => ({
  missingDetails: true,
  selectedCustomer: null,
  setSelectedCustomer: (customer) =>
    set((state) => ({ ...state, selectedCustomer: customer })),
  setMissingDetails: (payload) =>
    set((state) => ({ ...state, missingDetails: payload })),
}))

export default useCustomerStore
